export const tooltipData = {
    
  "STATEMENT TYPE*": {
    title: "Notes on Statement Type",
    description: [
      "Consolidated financial statement includes the financial statements of all subsidiaries.",
      "Consolidated statement shows the true position of the business as a whole.",
    ],
  },
  "Earnings (Cr)": {
    title: "Earnings trend",
    description: ["working on it"],
  },

  "Earnings Growth (%)": {
    title: "Earnings Growth",
    description: ["working on it"],
  },

  "Trade Receivables*": {
    title: "Notes on Trade Receivables",
    description: ["This is part of revenue where payment is not received yet"],
  },
  "Trade Receivables share in earnings (%)": {
    title: "Notes on Trade Receivables as share of earnings",
    description: [],
  },

  "Trade Receivables Growth (%)": {
    title: "Notes on Trade Receivables Growth",
    description: [
      "If this is growing in higher percentages, there is a problem",
    ],
  },

  "Operating Margin (%)": {
    title: "Operating Margin trend",
    description: ["working on it"],
  },

  "Operating Margin Growth (%)": {
    title: "Operating Margin Growth",
    description: [],
  },

  "Gross Profit (PBDIT - Cr)": {
    title: "Gross Margin trend",
    description: ["working on it"],
  },
  "Profit After Tax - PAT (Cr)": {
    title: "Profit After Tax trend",
    description: ["working on it"],
  },
  "PAT Growth (%)": {
    title: "Profit After Tax growth",
    description: ["working on it"],
  },
  "Profit Margin (%)": {
    title: "Notes on Profit Margin",
    description: [
      "Profit (which is not distributed as dividend) adds to Reserves in Balance sheet and eventually increases book value",
      "If margin is high, book value will grow faster",
    ],
  },

  "Profit Margin Growth (%)": {
    title: "Profit Margin Growth",
    description: [],
  },
  "2.Cashflow": {
    title: "Notes on Cashflows",
    description: [
      "Cashflow statement is sources and usage of cash",
      "Cashflow statement is difficult to fudge.",
      "Investors compare income statement with cashflow from operations to evaluate the quality of revenue and earnings reported. ",
      "If cashflow from operations is much less than profit, company might be window dressing - they are recognising profit though they are not getting paid. ",
      "Income from operations minus expenses minus taxes is what should go into cash flow. Not interest and depreciation, etc.",
    ],
  },

  "Depreciation And Amortisation Expenses (Cr)": {
    title: "Depreciation trend",
    description: ["working on it"],
  },

  "From Operations": {
    title: "Notes for Cashflow from Operations",
    description: [],
  },

  "From Financing": {
    title: "Notes for Cashflow from Financing",
    description: [
      "If interest rates fall, long-term debt will need to be refinanced which can further increase costs.",
      "Understand if they are paying off debts, bonds, issuing dividends, etc.",
      "Financing is mostly debt or equity. A positive debt number means more debt raised and same for equity. A negative debt number means debt paid or shares bought back",
    ],
  },

  "From Investments": {
    title: "Notes for Cashflow from Investments",
    description: [
      "A positive number for Investing means company might be selling off assets or closing operations in some plants. etc. Look at details of investing activities. If they are investing in growth, then its a good thing.",
      "Investment shown in cashflow statement for Property Plant and Equipment (PPE) reflects in the balance sheet PPE entry",
      "A positive number in investment will have corresponding reduction in PPE entry on balance sheet vs previous year, showing something was sold.",
    ],
  },

  "Free Cash Flow (Cr)": {
    title: "Free Cash Flow trend",
    description: ["working on it"],
  },

  "Cash Flow Growth Rate (%)": {
    title: "Cash Flow Growth Rate trend",
    description: ["working on it"],
  },
  "Change in Cash (Cr)": {
    title: "Notes for Change in Cash",
    description: [
      "To be updated once cash flow changes as fixed for investment and financing",
    ],
  },

  //put it quetes
  Shares: {
    title: "Shares trend",
    description: ["working on it"],
  },
  "Share Capital (Cr)": {
    title: "Share Capital trend",
    description: [
      "Called-up share capital: face value may be 10 INR but you can call only 6 INR per share. So for 1 lacs share, you have 6 lacs called-up share capital.",
      " The balance, that is 4 INR per share or total 4 lacs is a liability to the company. If the company fails, banks can ask company to pay this balance liability to recover its money or other lenders can also ask company to pay this amount. ",
      "Unpaid amount in share capital is the liability. In a limited company, liability of shareholder is limited to liability of unpaid share capital.",
    ],
  },

  //Change in Shares

  "Change in Shares (%)": {
    title: "Change in Shares",
    description: [
      "Look for companies which issue bonus shares. Its help in faster creation of wealth.",
      "When bonus shares are issued in 1:1 proportion, the price of stock is halved. But face value is not reduced. When shares are split, the price and face value, both are reduced in same proportion as per the split ratio. ",
      "DVR - Differential Voting Rights - some stock have less voting rights and are compensated by higher dividend rate or discounted value of shares when purchased. These are called DVR Shares",
      "Preferred Shares receive a fixed dividend and return of capital after a fixed number of years. The behavior of returns are similar to that of bond. However, owner of Preferred Shares cannot insist on dividend on return of capital. They only have preference over equity shareholders. Past and current dividend due of preferred shareholders have to be paid first before dividend can be paid on common stock shareholders.",
      "Warrants are purchased from company, giving rights to purchase stock at a fixed price. They have long duration like 5-7 years.",
      "Warrants are often used as sweetner for issue of Bonds or NCD. Warrants are detachable when issued like this - that is warrant or the underlying instrument can be sold separately",
    ],
  },
  "Face Value (INR)": {
    title: "Face Value",
    description: [],
  },

  "EPS (INR)": {
    title: "Notes on EPS",
    description: [
      "Earnings per share (EPS) is a company's net profit divided by the number of common shares it has outstanding.",
      "Basic EPS does not factor in the dilutive effect of shares that could be issued by the company. When the capital structure of a company includes items such as stock options, warrants, restricted stock units (RSU), these investments—if exercised—could increase the total number of shares outstanding in the market.",
    ],
  },

  "Dividend Per Share (INR)*": {
    title: "Dividend Per Share trend",
    description: [
      "The declaration date is the day on which the board of directors announces the dividend.",
      "The ex-date or ex-dividend date is the trading date on (and after) which the dividend is not owed to a new buyer of the stock. The ex-date is one business day before the date of record. ",
      "The date of record is the day on which the company checks its records to identify shareholders of the company. An investor must be listed on that date to be eligible for a dividend payout.",
      "The date of payment is the day the company mails out the dividend to all holders of record. This may be a week or more after the date of record.",
    ],
  },

  "Dividend Yield (%)": {
    title: "Dividend Yield trend",
    description: ["working on it"],
  },

  "Payout Ratio (%)": {
    title: "Notes on Payout Ratio",
    description: [
      "The payout ratio is the percentage of net income that is returned to common shareholders through dividends",
    ],
  },

  "EPS Contribution to Book Value Change (%)*": {
    title: "EPS Contribution to Book Value Change trend",
    description: ["working on it"],
  },

  "Book Value (INR)*": {
    title: "Book Value trend",
    description: ["working on it"],
  },
  "Reserves (Cr)": {
    title: "Reserves",
    description: [
      "Reserves are retained earnings not distributed to shareholders, since the starting of the company.",
      "If reserves are growing fast, look at Return on Equity (ROE) so that we know company is actually generating better returns for shareholders.",
      "Reserves is made up of revenue reserve and capital reserve. Revenue reserve is from profit. Capital reserve is from re-evaluation of assets like land. A stock of face value INR 10 but sold in market directly by company at 500 will create INR 10 in issued capital and INR 490 in capital reserve. A reserve may not necessarily be in cash form - as we have seen the re-evaluation of assets increases capital reserve but no cash is added!",
      "Companies create General Reserve to pay dividends in years where there is no profit.",
    ],
  },

  "Reserves Contribution to BV (%)": {
    title: "Reserves Contribution to BV trend",
    description: ["working on it"],
  },

  "Reserve based on Depreciation (Cr)": {
    title: "Reserve based on Depreciation trend",
    description: ["working on it"],
  },

  "Return on Capital Employed (%)": {
    title: "Notes on Return on Capital Employed (ROCE)",
    description: [
      "Profit before Interests and Taxes (Depreciation must be deducted) / Capital Employ",
      "where Capital Employed = Total Assets - Current Liabilities = Non current assets + current assets - current liabilities = Shareholder fund + Non current liabilities (as current liabilities do not carry any interest to be paid )",
      "If Return on capital raised via debt is more than the the interest paid, Equity holders enjoy the balance. This benefit is high for shareholders if leverage is high",
      "ROCEincludes return on debt also but ROE is return on equity only. The higher the debt and as long as it can be paid well, the ROE is very high. That makes it very attractive for shareholders! Same business can be more attractive for shareholders if you raise more debt and less equity",
      "ROCE can fluctuate a lot if business earnings is not stable",
    ],
  },

  "Leverage (DebttoEquity) Ratio": {
    title: "Notes on Leverage (DebttoEquity Ratio",
    description: [
      "It reflects the ability of shareholder equity to cover all outstanding debts in the event of a business downturn. Equity here covers reserves and surplus.",
      "When using the debt/equity ratio, it is very important to consider the industry within which the company exists",
    ],
  },
  "Interest Coverage (Finance cost/Profit Before Tax)": {
    title: "Notes on Interest Coverag",
    description: [
      "If finance coverage goes down for highly leveraged company, exit!",
    ],
  },

  "Leverage Effect (%)": {
    title: "Notes on Leverage Effect",
    description: [
      "( Debt / Equity ) * ( ROCE - Interest Rate)",
      "Rate of Interest is assumed at 12% for corporates",
    ],
  },

  "Return on Equity (%)": {
    title: "Notes on Return on Equity (ROE)",
    description: [
      "This is equal to Net Income / Equity (Share Capital + Retained Earnings from past + PAT - Dividends)",
      "The This tells us if the accumulated reserves are generating good returns or not.",
      "The first potential issue with a high ROE could be inconsistent profits. Imagine a company, LossCo, that has been unprofitable for several years. Each year’s losses are recorded on the balance sheet in the equity portion as a “retained loss.” The losses are a negative value and reduce shareholder equity. Assume that LossCo has had a windfall in the most recent year and has returned to profitability. The denominator in the ROE calculation is now very small after many years of losses, which makes its ROE misleadingly high.",
      "If a company has been borrowing aggressively, it can increase ROE because equity is equal to assets minus debt. The more debt a company has, the lower equity can fall. A common scenario is when a company borrows large amounts of debt to buy back its own stock. This can inflate earnings per share (EPS), but it does not affect actual performance or growth rates.",
    ],
  },

  "ROI (%)": {
    title: "Notes on ROI",
    description: [
      "Profit before Interests and Taxes (Depreciation must be deducted) / Total Investments  (Investment includes money as debt or share capital)",
      "This ratio is same as ROTA (Return on Total Assets), the denoninator is total assets",
    ],
  },

  "Total Asset Turnover Ratio": {
    title: "Notes on Total Asset Turnover Ratio",
    description: [
      "Total Revenue / Total Assets = (Revenue from Business Operations + Other Income) / (Total assets including investments in banks, mutual funds, bonds, equity, etc.) ",
      " Assets = Debt (or liabilities) + Equity (Use of funds = source of funds)",
      "OR, Assets = Debt (or liabilities) + Equity + Income - Expenses",
      "Above tells us how much we get in return for every 1 INR invested in business.",
      "We can see trend of asset turnover ratio over time ",
      "We can break down total asset turnover into fixed asset and current asset turn over ratios",
      "The ratio will now include income from fixed assets and total fixed assets. Current assets performance should be measured using inventory, receivables and cash.",
      "We cannot use current investment as its surplus cash invested elsewhere which may not impact operations. Any item in current asset section of balance sheet, should not be included here if we don't understand how it impacts operations in current year.",
      "Current Asset Turnover Ratio = Sales / Current Assets (Compare this ratio over a period of few years to see if there is any improvement.)",
    ],
  },

  "Accounts Receivable Turnover Rate": {
    title: "Notes on Accounts Receivable Turnover Rate",
    description: [
      "This is equal to Sales / Account Receivable",
      "If 100 INR was receivable and sales for 1000, 10 cycles of account receivables could have happen in the month. Higher the number, the better",
      "Account receivable used in above equation should be average of account receivable at start and end of year. So average of A/R in this year and last year balance sheet.",
    ],
  },

  "Accounts Receivable Days": {
    title: "Notes on Accounts Receivable Days",
    description: [
      "This is equal to 365 / Accounts Receivable Turnover rate = no of days it takes me to collect the money due for account receivable.",
      "The smaller this number, the better. If this is going up, company has problem in collecting payment which is not a good cycle.",
    ],
  },
  "Increase in Accounts Receivable Days (%)": {
    title: "Notes on",
    description: [],
  },

  "Inventory Turnover Rate": {
    title: "Notes on Inventory Turnover rate",
    description: [
      "This is equal to Cost of Goods Sold / Inventory",
      "Inventory should be average at start and end of year. So average of Inventory in this and last year balance sheet. The bigger the no, the better.",
    ],
  },

  "Inventory Days": {
    title: "Notes on increase in Accounts Receivable Days (%)",
    description: [
      "This is equal 365 / Inventory Turnover rate = no of days it takes to sell the inventory.",
      "The smaller the no, the better.",
    ],
  },

  "Increase in Inventory Days (%)": {
    title: "Notes on",
    description: [],
  },

  "Working Capital Days": {
    title: "Notes on Working Capital Days",
    description: ["Inventory Days + Collection Days"],
  },

  "Payable Days": {
    title: "Notes on Payable Days",
    description: [
      "365 / Payables Turnover Ratio = Payables / Raw materials consumed per day",
      "Reduction in Payable Days reduces materials cost and improves profit margin ",
      "If a company pays faster, its current liabilities will be lower and hence lower ROCE.",
      "Payables Turnover Ratio  = Total Expenses / Payables ",
    ],
  },

  "Estimated Dividend Growth Rate (%)": {
    title: "Notes on Estimated Dividend Growth Rate",
    description: [
      "The dividend growth rate can be estimated by multiplying ROE by the payout ratio. This formula gives us a sustainable dividend growth rate. The company A dividend growth rate is 4.5%, or ROE times the payout ratio, which is 15% times 30%. Business B's dividend growth rate is 1.5%, or 15% times 10%. A stock that is growing its dividend far above or below the sustainable dividend growth rate may indicate risks that should be investigated.",
    ],
  },

  "Actual Dividend Growth Rate (%)": {
    title: "Notes on Actual Dividend Growth Rate",
    description: [],
  },
  "Growth Rate (%)": {
    title: "Notes on Growth Rate",
    description: [
      "To estimate a company’s future growth rate, multiply the ROE by the company’s retention ratio. This is also called as sustainable growth rate. A growth rate that is far above or below the sustainable rate warrants additional investigation.",
    ],
  },

  Cash: {
    title: "Notes on Cash",
    description: [
      "Check if the cash with company is more than the current liabilities on the balance sheet. This is safe way of making sure company can pay for next 1 year even if no sales happen or sales drops, etc. Even better if cash is more than total liabilities. Unlikely but worth checking.",
      "Current Assets are assets which are likely to change its form within one year period. But not all of them will translate into cash.",
    ],
  },

  "Retained Profit/Change in Reserves": {
    title: "Notes on this ratio",
    description: [
      "It tells us if the net profit translates into change in Shareholder's equity, which is retained earnings or reserves",
    ],
  },

  "Current Ratio": {
    title: "Notes on Current Ratio",
    description: ["Current Assets / Current Liabilities"],
  },

  "Quick Ratio": {
    title: "Notes on Quick Ratio",
    description: [
      "(Current Assets - Inventory)/Current Liabilities",
      "Quick ratio is considered more conservative than the current ratio because its calculation factors in fewer items.",
      "quick ratio, often referred to as the acid-test ratio, includes only assets that can be converted to cash within 90 days or less",
    ],
  },
  "Total Debt (Cr)": {
    title: "Total Debt trend",
    description: ["working on it"],
  },

  //
  "Current Liabilities (Cr)": {
    title: "Current Liabilities trend",
    description: [
      "Can current liabilities be paid easily using cash and other current assets, minus the inventory?",
    ],
  },

  "Finance Cost (Cr)": {
    title: "Finance Cost trend",
    description: ["working on it"],
  },
};
